import { useQuery } from "@apollo/client";
import styled from "@xstyled/styled-components";

import { JobFeature, UpsellRelevantCandidatesDocument } from "@hire/schema";
import { palette } from "@otta/design-tokens";
import { Card, Button, Text, Spacing } from "@otta/design";
import { useRequiredParams } from "@hire/util/routing";
import { Link } from "@hire/components/links";
import { useJobAuthorization } from "@hire/providers/authorization";

const HeadingWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20;
  padding-top: 5;
`;

const StageColumn = styled(Card)`
  background: ${palette.brand.green};
  padding: md;
  border-radius: 8;
  height: fit-content;
  flex-basis: 20;
`;

export const ProUpsellPipelineStage = ({ isPaying }: { isPaying: boolean }) => {
  const { loading, granted } = useJobAuthorization(JobFeature.Sourcing);

  const { jobId } = useRequiredParams(["jobId"]);
  const { data } = useQuery(UpsellRelevantCandidatesDocument, {
    skip: loading || !granted,
    variables: { id: jobId },
  });

  const numRelevantCandidates =
    data?.companyJob?.personalisedCandidates?.total ?? null;

  const upgrade = isPaying
    ? "adding Sourcing to your plan"
    : "upgrading to Pro";

  const message = numRelevantCandidates
    ? `Source ${numRelevantCandidates} relevant candidates by ${upgrade}.`
    : `Source relevant candidates by ${upgrade}.`;

  return granted || loading ? null : (
    <StageColumn>
      <HeadingWrapper>
        <Text bold>Talent pool</Text>
      </HeadingWrapper>
      <Spacing>
        <Text>{message}</Text>
        <Button
          as={Link}
          underline={false}
          level="primary"
          to="https://employers.welcometothejungle.com/upgrade-today"
          newTab
          style={{ whiteSpace: "nowrap" }}
        >
          Book a demo
        </Button>
      </Spacing>
    </StageColumn>
  );
};
